'use client';

import { c as _c } from "react/compiler-runtime";
import { getPreDiscountPrice, hasLoyaltyPricing } from '~/utils/loyaltyPricing';
import { pricePerPerson as pricePerPersonForPax } from '~/utils/paxHelpers';
import { useTripOverviewSummary } from './useTripOverviewSummary';
import { useTripPriceSummary } from './useTripPriceSummary';
export const useTripLoyaltyPricing = () => {
  const $ = _c(25);
  const {
    overviewData,
    adultCount,
    childAges
  } = useTripOverviewSummary();
  const {
    totalPrice,
    formatPrice
  } = useTripPriceSummary();
  const loyaltyDiscount = overviewData?.loyaltyDiscountPercentage ?? 0;
  const loyaltyTierName = overviewData?.loyaltyTierName ?? undefined;
  const loyaltyTierId = overviewData?.loyaltyTierId ?? undefined;
  if (!hasLoyaltyPricing(loyaltyDiscount, loyaltyTierName) || totalPrice === undefined) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        hasLoyaltyDiscount: false as const
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== adultCount || $[2] !== childAges || $[3] !== formatPrice || $[4] !== loyaltyDiscount || $[5] !== loyaltyTierId || $[6] !== loyaltyTierName || $[7] !== totalPrice) {
    const perPerson = pricePerPersonForPax(totalPrice, adultCount, childAges);
    t0 = true as const;
    t1 = loyaltyDiscount;
    t2 = loyaltyTierId;
    t3 = loyaltyTierName;
    if ($[14] !== formatPrice || $[15] !== loyaltyDiscount || $[16] !== totalPrice) {
      t4 = formatPrice(getPreDiscountPrice(totalPrice, loyaltyDiscount));
      $[14] = formatPrice;
      $[15] = loyaltyDiscount;
      $[16] = totalPrice;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    t5 = formatPrice(getPreDiscountPrice(perPerson, loyaltyDiscount));
    $[1] = adultCount;
    $[2] = childAges;
    $[3] = formatPrice;
    $[4] = loyaltyDiscount;
    $[5] = loyaltyTierId;
    $[6] = loyaltyTierName;
    $[7] = totalPrice;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = {
      hasLoyaltyDiscount: t0,
      loyaltyDiscount: t1,
      loyaltyTierId: t2,
      loyaltyTierName: t3,
      originalTotalFormatted: t4,
      originalPerPersonFormatted: t5
    };
    $[18] = t0;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};